/**
 * InspectionItemEvidence
 * Per-item evidence thumbnails within a checklist item card.
 */
import { ImageIcon } from 'lucide-react';
import type { InspectionEvidence } from '@/hooks/useInspectionEvidence';

interface InspectionItemEvidenceProps {
  evidence: InspectionEvidence[];
}

export function InspectionItemEvidence({ evidence }: InspectionItemEvidenceProps) {
  if (evidence.length === 0) return null;

  return (
    <div className="flex gap-1 flex-wrap">
      {evidence.map(e => (
        <div key={e.id} className="w-10 h-10 rounded border overflow-hidden bg-muted/50 flex-shrink-0">
          {e.signedUrl ? (
            <img src={e.signedUrl} alt="Evidence" className="w-full h-full object-cover" />
          ) : (
            <div className="w-full h-full flex items-center justify-center">
              <ImageIcon className="h-3 w-3 text-muted-foreground" />
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
